import { Table } from '../../models';
import { CommandOptions } from '../../interfaces/options';
import { Localization } from '../../compile';

export function DefaultEditCommandOptions<T>(): CommandOptions {
	return <CommandOptions>{
		label: Localization.Edit,
		css: 'hehe-icons-editpen',
		command: (item: T, table: Table<T>) => {
			table.edit(item);
		}
	};
}
